import React, { useEffect, useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material'
import { documentTypeLabels, documentTypeOf } from '../../../helpers/logisticaHelper'
import { StyledTextField, DarkButton } from '../../../ui/StyledComponents'

// StyledTextField fija la altura en 42px: el multiline la necesita libre para crecer con el texto
const notaFieldSx = {
    '& .MuiOutlinedInput-root': { height: 'auto', alignItems: 'flex-start' },
}

// Nota de una línea de la planilla: texto plano sin límite de largo. `onSave` recibe el texto tal cual; vacío o
// solo espacios se guarda como nulo. En solo lectura muestra la nota sin dejar editarla
export default function NotaDialog({ open, documento, readOnly, onClose, onSave }) {
    const [note, setNote] = useState('')

    useEffect(() => {
        if (open) setNote(documento?.note ?? '')
    }, [open]) // eslint-disable-line react-hooks/exhaustive-deps

    const tipo = documentTypeLabels[documentTypeOf(documento)] ?? ''

    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>
                {`Nota de ${tipo.toLowerCase()} ${documento?.documentNumber ?? ''}`}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ pt: 1 }}>
                    <StyledTextField
                        size="small"
                        label="Nota"
                        value={note}
                        onChange={(e) => setNote(e.target.value)}
                        multiline
                        minRows={1}
                        maxRows={12}
                        fullWidth
                        autoFocus={!readOnly}
                        InputProps={{ readOnly }}
                        sx={notaFieldSx}
                    />
                </Box>
                {!readOnly && (
                    <Typography variant="caption" color="text.secondary">
                        * La nota se guarda con la planilla. Dejala vacía para quitarla.
                    </Typography>
                )}
            </DialogContent>
            <DialogActions>
                {readOnly ? (
                    <Button onClick={onClose}>Cerrar</Button>
                ) : (
                    <>
                        <Button onClick={onClose}>Cancelar</Button>
                        <DarkButton onClick={() => onSave(note)}>Aceptar</DarkButton>
                    </>
                )}
            </DialogActions>
        </Dialog>
    )
}
